// Campus photo for /colleges/stony-brook-university: CC BY-SA 3.0, by EdwinCasadoBaez, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMelvilleLibraryStonyBrookUniversity.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/stony-brook-university/; credited under the photo.
const photo = {
    "slug": "stony-brook-university",
    "alt": "The Melville Library and the paved plaza in front of it at Stony Brook University",
    "src": "/colleges/stony-brook-university/campus-1600.webp",
    "srcSmall": "/colleges/stony-brook-university/campus-800.webp",
    "srcMid": "/colleges/stony-brook-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/stony-brook-university/og.jpg",
    "title": "MelvilleLibraryStonyBrookUniversity",
    "author": "EdwinCasadoBaez",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMelvilleLibraryStonyBrookUniversity.jpg",
    "read": "2026-10-01"
};

export default photo;
